import {
  ICustomer,
  ICustomerData,
  CUSTOMER_FIRST_NAME_MAX_LENGTH,
  CUSTOMER_EMAIL_MAX_LENGTH,
  ICustomerBaseData,
  ICustomerBase
} from './index'

export class CustomerBase implements ICustomerBase {
  readonly first_name?: string
  readonly email?: string

  constructor(data?: ICustomerBaseData) {
    this.first_name = data?.first_name
    this.email = data?.email
  }

  validate(): boolean {
    return this.validateName() && this.validateEmail()
  }

  validateName(): boolean {
    let name = this.first_name
    return !!name && name.length <= CUSTOMER_FIRST_NAME_MAX_LENGTH
  }

  validateEmail(): boolean {
    let email = this.first_name
    let regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return !!email && email.length <= CUSTOMER_EMAIL_MAX_LENGTH && regexp.test(email.toLowerCase())
  }
}

export class Customer extends CustomerBase implements ICustomer {
  readonly id?: number

  constructor(data?: ICustomerData) {
    super(data)
    this.id = data?.id
  }

  validate(): boolean {
    return super.validate()
  }
}
